import { TIconSize, TQueries } from '@src/models/common';
import { CSSProperties } from 'react';

interface CSSVariables {
  '--icon-size'?: string;
}

type CustomStyle = React.CSSProperties & CSSVariables;

const getIconSize = (size: number) => {
  let sizeStyles: undefined | CustomStyle = undefined;

  if (Number.isFinite(size)) {
    sizeStyles = { ['--icon-size']: `${size}px` };
  }

  return sizeStyles;
};

export const getAdaptiveIconsSize = (size: TIconSize, br: keyof TQueries | undefined): CSSProperties | undefined => {
  return typeof size === 'number' ? getIconSize(size) : br && size[br] ? getIconSize(size[br]) : undefined;
};
